import { getOrdinalSuffix } from './global/common';

export const formatN = (num: number, decimal = 1) => {
  let isNegative = false;
  if (num < 0) {
    isNegative = true;
    num *= -1;
  }
  let symbol = '';
  if (num >= 1e12) {
    num /= 1e12;
    symbol = 'T';
  } else if (num >= 1e9) {
    num /= 1e9;
    symbol = 'B';
  } else if (num >= 1e6) {
    num /= 1e6;
    symbol = 'M';
  } else if (num >= 1000) {
    num /= 1000;
    symbol = 'k';
  }
  return `${isNegative ? '-' : ''}${num.toFixed(decimal).replace(/\.0$/, '')}${symbol}`;
};

export const convertTime = (time: string) => {
  const parts = time.split(':');
  let suffix = 'am';
  if (Number(parts[0]) >= 12) {
    suffix = 'pm';
    if (Number(parts[0]) > 12) {
      parts[0] = (Number(parts[0]) - 12).toString();
    }
  }
  if (parts[0].length < 2) {
    parts[0] = `0${parts[0]}`;
  }
  if (parts[1].length < 2) {
    parts[1] = `0${parts[1]}`;
  }
  return `${parts.join(':')}${suffix}`;
};

export const convertDate = (date: Date) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const ret = `${date.getDate()}${getOrdinalSuffix(date.getDate())} ${months[date.getMonth()]}${date.getFullYear() !== (
    new Date()).getFullYear() ? ` ${date.getFullYear()}.` : ''}`;
  const date2 = new Date();
  const ret1 =
    `${date2.getDate()}${getOrdinalSuffix(date2.getDate())} ${months[date2.getMonth()]}${date2.getFullYear() !== (
      new Date()).getFullYear() ? ` ${date2.getFullYear()}.` : ''}`;
  return `${ret === ret1 ? 'Today' : ret} ${convertTime(`${date.getHours()}:${date.getMinutes()}`)}`;
};

export const convertDate2 = (date: Date) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const ret = `${days[date.getDay()]}, ${date.getDate()} ${months[date.getMonth()]}${date.getFullYear() !== (
    new Date()).getFullYear() ? ` ${date.getFullYear()}.` : ''}`;
  const date2 = new Date();
  const ret1 = `${days[date2.getDay()]}, ${date2.getDate()} ${months[date2.getMonth()]}${date2.getFullYear() !== (
    new Date()).getFullYear() ? ` ${date2.getFullYear()}.` : ''}`;
  return ret === ret1 ? 'Today' : ret;
};

export const convertDate21 = (date: Date) => {
  const months = ['January', 'Febuary', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
    'October', 'November', 'December'];
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const ret = `${days[date.getDay()]}, ${date.getDate()} ${months[date.getMonth()]}${date.getFullYear() !== (
    new Date()).getFullYear() ? ` ${date.getFullYear()}.` : ''}`;
  const date2 = new Date();
  const ret1 = `${days[date2.getDay()]}, ${date2.getDate()} ${months[date2.getMonth()]}${date2.getFullYear() !== (
    new Date()).getFullYear() ? ` ${date2.getFullYear()}.` : ''}`;
  return ret === ret1 ? 'Today' : ret;
};

export const months = [
  'January', 'Febuary', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
];
export const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const convertDate22 = (date: Date) => {
  const ret = `${date.getDate()} ${months[date.getMonth()]}${date.getFullYear() !== (
    new Date()).getFullYear() ? ` ${date.getFullYear()}` : ''}`;
  const date2 = new Date();
  const ret1 = `${date2.getDate()} ${months[date2.getMonth()]}${date2.getFullYear() !== (
    new Date()).getFullYear() ? ` ${date2.getFullYear()}` : ''}`;
  return ret === ret1 ? `Today, ${ret}` : ret;
};

export const convertDate23 = (date: Date) => {
  const months0 = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const ret = `${date.getDate()} ${months0[date.getMonth()]}${date.getFullYear() !== (
    new Date()).getFullYear() ? ` ${date.getFullYear()}` : ''}`;
  const date2 = new Date();
  const ret1 = `${date2.getDate()} ${months0[date2.getMonth()]}${date2.getFullYear() !== (
    new Date()).getFullYear() ? ` ${date2.getFullYear()}` : ''}`;
  return ret === ret1 ? 'Today' : ret;
};

export const convertDate223 = (date: Date) => {
  const months0 = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const ret = `${date.getDate()} ${months0[date.getMonth()]}${date.getFullYear() !== (
    new Date()).getFullYear() ? ` ${date.getFullYear()}` : ''}`;
  return ret;
};

export const convertDate3 = (date: Date) => {
  const ret = `${date.getDate()}-${months[date.getMonth()]}${date.getFullYear() !== (
    new Date()).getFullYear() ? `-${date.getFullYear()}` : ''}`;
  return ret;
};

/**
 * Inclusive span wording — same language as metrics time.
 * Same instant → "1 day". Longer → "2 days", "1 year 2 months".
 */
export const formatInclusiveDateSpan = (startD: Date, endD: Date): string => {
  if (Number.isNaN(+startD) || Number.isNaN(+endD)) return '1 day';
  const startMs = +startD;
  const endMs = +endD;
  const earlier = new Date(Math.min(startMs, endMs));
  const later = new Date(Math.max(startMs, endMs));
  let years = later.getFullYear() - earlier.getFullYear();
  let months = later.getMonth() - earlier.getMonth();
  let days = later.getDate() - earlier.getDate();
  if (days < 0) {
    months -= 1;
    days += new Date(later.getFullYear(), later.getMonth(), 0).getDate();
  }
  if (months < 0) {
    years -= 1;
    months += 12;
  }
  // Inclusive leftover days; 29+ rolls into a month (metrics time rule).
  days += 1;
  if (days >= 29) {
    months += 1;
    days = 0;
  }
  if (months >= 12) {
    years += 1;
    months = 0;
  }
  const parts = [
    years ? `${years} year${years === 1 ? '' : 's'}` : '',
    months ? `${months} month${months === 1 ? '' : 's'}` : '',
    days ? `${days} day${days === 1 ? '' : 's'}` : '',
  ].filter(Boolean);
  return parts.join(' ') || '1 day';
};

/** Combined SKU date — "1 day", "3 days", "1 year 2 months". */
export const formatCombinedSkuDateLabel = (startD: Date, endD: Date): string => (
  formatInclusiveDateSpan(startD, endD)
);

export const isValidatedEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|.('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const truncate = (str: string, max?: number) => {
  max = max || 18;
  if (str.length > max) {
    return `${str.substring(0, max)}...`;
  }
  return str;
};

export const ENTITY_ID_LENGTH = 12;

/** 12-char alphanumeric id for hotels and customers (matches BE/Firestore). */
export const randomEntityId = (): string => {
  let id = '';
  while (id.length < ENTITY_ID_LENGTH) {
    id += Math.random().toString(36).slice(2);
  }
  return id.slice(0, ENTITY_ID_LENGTH);
};

/** UUID v4 for room types, rate plans, and other settings entities. */
export const generateUuid = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
};

/** Accept new random ids, legacy 8-char ids, or legacy numeric ids. */
export const isEntityId = (id: string | number | null | undefined): boolean => {
  if (id === null || id === undefined || id === '') return false;
  const s = String(id);
  return /^[a-z0-9]{8}$/i.test(s) || /^[a-z0-9]{12}$/i.test(s) || /^\d+$/.test(s);
};

/** Min chars before any booking-token search runs (hospitality, check-in, reservations, keys). */
export const TOKEN_SEARCH_MIN = 5;

/** Strip separators guests often omit when reading an OTA confirmation. */
export const sanitizeBookingRef = (value: string): string => (
  String(value || '').replace(/(?:-|_|:|\s)+/g, '')
);

/**
 * Case-insensitive match on the stored booking ref (LodgeFirst token or OTA
 * reservation code — both live on `book.token`). Ignores - _ : and spaces.
 */
export const bookTokenMatchesQuery = (
  token: string | null | undefined,
  query: string,
  mode: 'includes' | 'exact' = 'includes',
) => {
  const qRaw = query.trim().toLowerCase();
  if (qRaw.length < TOKEN_SEARCH_MIN || !token) return false;
  const q = sanitizeBookingRef(qRaw);
  const t = sanitizeBookingRef(token.toLowerCase());
  if (!q || !t) return false;
  return mode === 'exact' ? t === q : t.includes(q);
};

/** Booking tokens are always this many characters (9 random + room-id first char). */
export const BOOKING_TOKEN_LENGTH = 10;

export const getBookToken = (id: string | undefined) => {
  // 9 base36 chars + first char of room id (= BOOKING_TOKEN_LENGTH)
  const randomPart = (
    Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)
  ).slice(0, BOOKING_TOKEN_LENGTH - 1);
  return `${randomPart}${(id || '0').toString().split('')[0]}`.toUpperCase();
};

// eslint-disable-next-line no-unused-vars
export const getMerchantFee = (total: number) => {
  // const totalPlusPayFee = total * (103 / 100);
  // const payFee = totalPlusPayFee - total > 4000 ? 4000 : totalPlusPayFee - total;
  // const my500extra = total >= 20000 ? 500 : 0;
  const merchantFee = 500;// (Math.ceil((payFee + my500extra) / 100) * 100) + 200 + 300;
  return merchantFee;
};

export const convertTime1 = (date: Date) => {
  return `${date.getHours() < 10 ? '0' : ''}${date.getHours()}:${date.getMinutes() < 10 ? '0' : ''
  }${date.getMinutes()}`;
};

export const convertTime2 = (date: Date) => {
  return `${convertTime(`${date.getHours()}:${date.getMinutes()}`)}`;
};

const convertTime22 = (date: Date) => {
  return `${convertTime(`${date.getHours()}:${date.getMinutes()}`)}:${date.getSeconds() < 10 ? `0${date.getSeconds()}`
    : date.getSeconds()}`;
};

export const getTaxRef = (name: string, email: string, amount: string) => {
  return `payment:FOR-${name}-${email}_AMT:${amount}_${convertDate3(new Date())}_${convertTime22(new Date())}`;
};

export const isTimeFormat = (value: string, max: number) => {
  if (value[2] === '0') value = value.substring(0, 2);
  const isPass = !Number.isNaN(Number(value)) && !value.includes('.')
    && Number(value) <= max && value.length <= 3;
  return isPass;
};

export const getTimeSetFormat = (value: string, max: number) => {
  return Number(value) > max && value[2] === '0' ? value.substring(0, 2) : value;
};

export const getTimeFormat = (value: string) => {
  return (Number(value) < 10 && Number(value) > 0) ? `0${value}` : value;
};

export const getApiUrl = () => process.env
  .NODE_ENV === 'production' ?
  'https://backend-30792374934.us-central1.run.app/'
  : 'http://localhost:8200/';

/** Marketing site (lodgefirst_home). Dev → local Next app; prod → lodgefirst.com. */
export const getMarketingSiteUrl = (path = '/') => {
  const base = process.env.NODE_ENV === 'production'
    ? 'https://lodgefirst.com'
    : 'http://localhost:3001';
  if (!path || path === '/') return base;
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
};

/** Survives liveView clear on logout so /signin can still send demos back to /try. */
const LIVE_DEMO_EXIT_TO_TRY_KEY = 'live_demo_exit_to_try';

export const markLiveDemoExitToTry = () => {
  try {
    sessionStorage.setItem(LIVE_DEMO_EXIT_TO_TRY_KEY, '1');
  } catch {
    /* ignore */
  }
};

export const clearLiveDemoExitToTry = () => {
  try {
    sessionStorage.removeItem(LIVE_DEMO_EXIT_TO_TRY_KEY);
  } catch {
    /* ignore */
  }
};

export const shouldExitLiveDemoToTry = () => {
  try {
    return sessionStorage.getItem(LIVE_DEMO_EXIT_TO_TRY_KEY) === '1';
  } catch {
    return false;
  }
};

/** Leave the app SPA for the marketing try-live picker. */
export const redirectLiveDemoToTry = () => {
  clearLiveDemoExitToTry();
  window.location.href = getMarketingSiteUrl('/try');
};
